import { render } from "./PaymentTestView.vue?vue&type=template&id=ae2a9caa"
import script from "./PaymentTestView.vue?vue&type=script&lang=js"
export * from "./PaymentTestView.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__